<template>
<a class="nav-link pointer-click" @click="openNotificationModal()">
    <i class="fas fa-bell fa-fw"></i>
    <span class="badge badge-danger" v-if="totalLabel > 0">{{ totalLabel }}</span>
</a>
</template>

<script>
    export default {
        data(){
            return {
                totalLabel: null
            }
        },
        created(){
            this.getNotificationLabel()
        },
        methods: {
            openNotificationModal(){
                EventBus.$emit('create-clausula');
                this.setNotificationsRead()
                this.totalLabel = 0;
            },
            getNotificationLabel(){
                axios.get(this.$url+'/api/adm/notifications/unreadNotifications')
                    .then(response => {
                        this.totalLabel = response.data.length
                    })
                    .catch(error => {
                        console.log(error)
                    });
            },
            setNotificationsRead(){
                axios.post(this.$url+'/api/adm/notifications/markNotificationsRead')
	            .then(response => {

	            })
	            .catch(error => {
					this.errors = error.response.data.errors
				});
            }
        }
    }
</script>

<style scoped>
    .pointer-click {
        cursor: pointer;
    }
</style>
